import React, { FC, useEffect } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useData } from './use-data';
import Layout from './layout';
import { RoutePath } from './const';
import Home from './home';
import LegalNotice from './legal-notice';
import Quiz from './quiz';
import TabDuplicatePage from './tab-duplicate';

const Main: FC = () => {
  const { fetchData, data } = useData();
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (!data) {
    return null;
  }

  return (
    <Layout>
      <Routes>
        <Route path={RoutePath.HOME} element={<Home />} />
        <Route path={RoutePath.LEGAL_NOTICE} element={<LegalNotice />} />
        <Route path={`${RoutePath.LEGAL_NOTICE}/:country`} element={<LegalNotice />} />
        <Route path={`${RoutePath.FORM}/:flow`} element={<Quiz />} />
        <Route path={RoutePath.ERROR_DUPLICATE} element={<TabDuplicatePage />} />
        <Route path="*" element={<Navigate to={RoutePath.HOME} />} />
      </Routes>
    </Layout>
  );
};

export default Main;
